import React from 'react';
export const RatingBattery = ({...props} ) => {
    return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 190 190" width="16" height="16" {...props}>
        <defs>
            <path id="star" d="M50 8 L61.8 35.3 L91.7 38.2 L69.4 57.7 L75.5 87.1 L50 72.5 L24.5 87.1 L30.6 57.7 L8.3 38.2 L38.2 35.3 Z" />
        </defs>

        <use href="#star" x="40" y="0" fill="1a1a1a" strokeWidth="3.5" strokeLinejoin="round" />


        <use href="#star" x="40" y="105" fill="1a1a1a" strokeWidth="3.5" strokeLinejoin="round" />

    </svg>);
};
